import { Grid, Stack, Switch, Tooltip, Typography, useTheme } from '@mui/material'
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded'
import React from 'react'
import { EmailMessageType, EventRepetitionReminderMode } from '../../services/api/sharedTypes/Email'
import { convertEmailMessageTypeToString, convertStringToEmailMessageType } from '../../utils/email-utils'
import CustomContainer from '../common/CustomContainer'
import EventRepetitionReminderModeSelect from './EventRepetitionReminderModeSelect'

interface EmailSwitchesProps {
    emailSwitches: Partial<Record<EmailMessageType, boolean>>
    eventRepetitionReminderMode: EventRepetitionReminderMode
    onChange: (emailSwitches: Partial<Record<EmailMessageType, boolean>>) => void
    onEventRepetitionReminderModeChange: (mode: EventRepetitionReminderMode) => void
}

const EmailSwitches: React.FC<EmailSwitchesProps> = ({
    emailSwitches,
    eventRepetitionReminderMode,
    onChange,
    onEventRepetitionReminderModeChange,
}: EmailSwitchesProps) => {
    const theme = useTheme()
    return (
        <CustomContainer bgColor={theme.palette.background.default}>
            <Typography variant='h6' color='primary' mb={3}>
                Odesílat připomínkové emaily
            </Typography>
            <Grid container columnSpacing={3} rowSpacing={2}>
                {Object.entries(emailSwitches).map(([key, value], index: number) => {
                    const emailMessageType = convertStringToEmailMessageType(key)
                    // RemindEventRepetition is driven by eventRepetitionReminderMode, rendered as a select below
                    if (emailMessageType === EmailMessageType.NotSet || emailMessageType === EmailMessageType.RemindEventRepetition)
                        return null
                    return (
                        <Grid item xs={6} key={index}>
                            <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ minHeight: 40 }}>
                                <Typography>{convertEmailMessageTypeToString(emailMessageType)}</Typography>
                                <Switch
                                    checked={value}
                                    onChange={(event) => {
                                        onChange({ ...emailSwitches, [key]: event.target.checked })
                                    }}
                                />
                            </Stack>
                        </Grid>
                    )
                })}
                <Grid item xs={6}>
                    <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2} sx={{ minHeight: 40 }}>
                        <Stack direction='row' alignItems='center' spacing={2} sx={{ minWidth: 0 }}>
                            <Typography>{convertEmailMessageTypeToString(EmailMessageType.RemindEventRepetition)}</Typography>
                            <Tooltip title='Připomínka se vytvoří za nastavenou dobu po dokončené a zaplacené akci. Dobu upravíš v nastavení emailů.'>
                                <HelpOutlineRoundedIcon color='disabled' fontSize='small' />
                            </Tooltip>
                        </Stack>
                        <EventRepetitionReminderModeSelect
                            value={eventRepetitionReminderMode}
                            onChange={onEventRepetitionReminderModeChange}
                        />
                    </Stack>
                </Grid>
            </Grid>
        </CustomContainer>
    )
}

export default EmailSwitches
